// utils/cookieCheck.ts
export const areThirdPartyCookiesBlocked = (): boolean => {
  try {
    // Try to set a test cookie with SameSite=None; Secure
    document.cookie = "test_cookie=1; SameSite=None; Secure";
    return !document.cookie.includes("test_cookie=1");
  } catch {
    console.warn("Error checking cookies");
    return true;
  }
};
